export default __webpack_public_path__ + "static/media/Automobiles.eb7bad9f.pdf";